import React from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/auth/useAuth';
import { FaLock, FaEnvelope } from 'react-icons/fa';

const Login = () => {
  const navigate = useNavigate();
  const {
    email,
    setEmail,
    password,
    setPassword,
    handleLogin,
    error,
  } = useAuth(() => {
    navigate('/home');
  });

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#130022] via-[#1b012c] to-[#0b0013] flex items-center justify-center relative overflow-hidden text-white">

      {/* Animated LootLayer background particles */}
      <div className="absolute inset-0 z-0">
        <div className="w-full h-full bg-[radial-gradient(#9333ea_1px,transparent_1px)] [background-size:20px_20px] opacity-10 animate-pulse" />
      </div>

      {/* Login Card */}
      <div className="relative z-10 bg-[#0e0a17] border border-purple-700 shadow-[0_0_50px_rgba(168,85,247,0.4)] rounded-3xl px-8 py-10 w-full max-w-md">
        <h2 className="text-4xl font-extrabold text-center mb-8 tracking-widest text-purple-400 drop-shadow-lg">
          🎮 LOGIN TO <span className="text-white">LOOTLAYER</span>
        </h2>

        <form className="space-y-6" onSubmit={handleLogin}>
          {/* Email Field */}
          <div>
            <label className="block text-sm font-semibold mb-1">Email</label>
            <div className="relative">
              <input
                type="email"
                placeholder="you@lootlayer.gg"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full pl-10 pr-4 py-3 bg-gray-900 border border-purple-700 text-white placeholder-purple-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 transition"
              />
              <FaEnvelope className="absolute left-3 top-1/2 transform -translate-y-1/2 text-purple-500" />
            </div>
          </div>

          {/* Password Field */}
          <div>
            <label className="block text-sm font-semibold mb-1">Password</label>
            <div className="relative">
              <input
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full pl-10 pr-4 py-3 bg-gray-900 border border-purple-700 text-white placeholder-purple-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 transition"
              />
              <FaLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-purple-500" />
            </div>
          </div>

          {/* Error Display */}
          {error && (
            <p className="text-sm text-red-400 text-center">{error}</p>
          )}

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-gradient-to-r from-purple-600 to-purple-800 hover:to-purple-900 text-white font-semibold py-3 rounded-lg shadow-lg uppercase tracking-widest transition-all"
          >
            🔐 Enter the Vault
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
